import GeneralReport from './GeneralReport';
export default GeneralReport;
